import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import { FONT_SIZE_MEDIUM_LARGE } from '../../constants';
import mq from '@/utils/media-queries';

export const StyledBase = styled.h1`
  font-weight: 300;
  font-size: ${toVw(FONT_SIZE_MEDIUM_LARGE)};

  ${props => props.onDark && 'color: #fff'};

  ${mq.tablet(css`
    font-size: ${toVwTablet(FONT_SIZE_MEDIUM_LARGE)};

    br {
      display: none;
    }
  `)};

  ${mq.mobile(css`
    font-size: ${toVwMobile(64)};
  `)};
`;

export const TitleBase = ({ children, html }) =>
  html ? (
    <span dangerouslySetInnerHTML={{ __html: html }} />
  ) : children ? (
    <React.Fragment>{children}</React.Fragment>
  ) : null;

TitleBase.propTypes = {
  html: PropTypes.string,
};

const Title = ({ className, children, html, ...rest }) => (
  <StyledBase className={className} {...rest}>
    <TitleBase html={html}>{children}</TitleBase>
  </StyledBase>
);

Title.propTypes = {
  html: PropTypes.string,
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title/index.js